
  import { PremiumServiceEventTypeEnum, PremiumServiceEventTypes, PremiumServiceProductTypeEnum, PremiumServiceRequestTypeEnum } from "@/enums/PremiumServiceEventTypes";
  import moment from "moment";
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        eventTypes: Object.values(PremiumServiceEventTypeEnum),
        requestTypes: Object.values(PremiumServiceRequestTypeEnum),
        productTypes: Object.values(PremiumServiceProductTypeEnum),
        date: {
          start: moment().subtract(1, 'week').format('YYYY-MM-DD'),
          end:   moment().format('YYYY-MM-DD')
        },
        picker: {
          start: false,
          end: false
        },
        loading: true,
        period: "week",
        periods: [
          { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Week"], value: "week" },
          { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Month"], value: "month" },
          { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Year"], value: "year" }
        ],
        headers: [
          {
            text: "Type",
            value: "serviceItemType"
          },
          {
            text: "Service Requests",
            align: "start",
            value: "requests.length"
          },
          { text: "Booked / Ordered by Family", value: "bookedByFamily" },
          { text: "Booked / Ordered by Resident", value: "bookedByResident" },
          { text: "Booked / Ordered by Staff", value: "bookByStaffName" }
        ],
        jsonFields: {
          "Type": "serviceItemType",
          "Service Requests": "requests.length",
          "Booked / Ordered by Family": {
            field: "requests",
            callback: value =>
              value.filter(request => request.bookByFamilyId).length
          },
          "Booked / Ordered by Resident": {
            field: "requests",
            callback: value =>
              value.filter(request => !request.bookByFamilyId).length
          }
        }
      };
    },
    created() {
      const { from, to } = this.initDateRange(this.$route, this.$router, this.date, { from: this.from, to: this.to });
      this.date.start = from;
      this.date.end = to;
      this.setPeriodFromDates();
    },
    async mounted() {
      await this.$store.dispatch("getAdditionalServices");
      await this.$store.dispatch(
        "getAdditionalServiceRequestsByDates",
        this.date
      );
      this.loading = false;
    },
    computed: {
      ...mapState({
        facility: state => (state as any).facilityModule.selectedFacility,
        services: state => (state as any).additionalServicesModule.additionalServices,
      }),
      requests() {
        return this.$store.state.additionalServicesModule.serviceRequests.map((s: any) => {

          const service = s

          if (this.eventTypes.includes(s.serviceItemType)) {
            service.serviceItemType = PremiumServiceEventTypes.Event
          }
          else if (this.requestTypes.includes(s.serviceItemType)) {
            service.serviceItemType = PremiumServiceEventTypes.Request
          }
          else if (this.productTypes.includes(s.serviceItemType)) {
            service.serviceItemType = PremiumServiceEventTypes.Product
          }
          else{
            service.serviceItemType = 'Undefined'
          }

          return service
        })

      },
      formattedStartDate() {
        return moment(this.date.start).format(this.facility.dateFormat)
      },
      formattedEndDate() {
        return moment(this.date.end).format(this.facility.dateFormat)
      },
      formattedSelectedDateRange() {
        return `${moment(this.date.start).format(this.facility.dateFormat)} - ${moment(this.date.end).format(this.facility.dateFormat)} `;
      },
      requestsByType() {
      const requestsByKeys = this.requests.reduce((accum, current) => {
        const serviceItemType = current.serviceItemType;

        if(serviceItemType?.length){
          if (!accum[serviceItemType]) {
            accum[serviceItemType] = { serviceItemType, requests: [current] };
          }
          else{
            accum[serviceItemType].requests.push(current);
          }
        }

        return accum;
      }, {});

      const resultArray = Object.values(requestsByKeys);

      return resultArray
    }
    },
    methods: {
      async handleChangePeriod(period) {
        this.period = period;

        const { start, end } = this.getRangeForPeriod(period);
        this.date.start = start;
        this.date.end   = end;

        this.$router.replace({ query: { ...this.$route.query, from: start, to: end } });
        await this.submit();
      },

      async submit() {
        this.loading = true;
        await this.$store.dispatch(
          "getAdditionalServiceRequestsByDates",
          this.date
        );
        this.loading = false;
      },
      getRangeForPeriod(period) {
        const end = moment().format('YYYY-MM-DD');

        if (period === 'week') {
          const start = moment(end, 'YYYY-MM-DD').subtract(6, 'days').format('YYYY-MM-DD');
          return { start, end };
        }
        if (period === 'month') {
          const start = moment(end, 'YYYY-MM-DD').subtract(1, 'month').add(1, 'day').format('YYYY-MM-DD');
          return { start, end };
        }
        if (period === 'year') {
          const start = moment(end, 'YYYY-MM-DD').subtract(1, 'year').add(1, 'day').format('YYYY-MM-DD');
          return { start, end };
        }
        return { start: this.date.start, end: this.date.end };
      },
      isISO(s: any){
         return typeof s === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s)
      },
      initDateRange(route: any, router: any, fallback: any, props?: any) {
        let from = this.isISO(route.query.from) ? route.query.from : (this.isISO(props?.from) ? props!.from! : fallback.start);
        let to = this.isISO(route.query.to)   ? route.query.to   : (this.isISO(props?.to)   ? props!.to!   : fallback.end);

        if (from > to) { const t = from; from = to; to = t; }

        if (route.query.from !== from || route.query.to !== to) {
          router.replace({ query: { ...route.query, from, to } });
        }

        return { from, to };
      },
      inferPeriod(from: string, to: string): 'week' | 'month' | 'year' | 'custom' {
        const start = moment(from, 'YYYY-MM-DD');
        const end   = moment(to,   'YYYY-MM-DD');
        if (!start.isValid() || !end.isValid()) return 'custom';

        const daysInclusive = end.diff(start, 'days') + 1;

        if (daysInclusive <= 7) return 'week';

        if (start.year() !== end.year()) return 'year';

        if (start.month() !== end.month()) return 'month';

        return 'custom';
      },
      setPeriodFromDates() {
        const next = this.inferPeriod(this.date.start, this.date.end);
        this.period = next === 'custom' ? this.period : next;
      }
    },
    watch: {
      'date.start': 'setPeriodFromDates',
      'date.end':   'setPeriodFromDates',
      '$route.query'(q) {
        if (q.from && q.to) this.setPeriodFromDates();
      }
    }
  };
